if (!customElements.get('jump-links')) {
  customElements.define(
    'jump-links',
    class JumpLinks extends HTMLElement {
      constructor() {
        super();

        this.links = this.querySelectorAll('.jump-links__link');
        this.sections = [...document.querySelectorAll('.custom-featured-collection')].filter(
          (section) => section.id && section.id.trim().length > 0
        );
        this.distanceFromTop = this.getDistanceFromTop(this);

        this._boundHandleScroll = this.handleScroll.bind(this);
        window.addEventListener('scroll', this._boundHandleScroll, { passive: true });
        window.addEventListener('resize', this._boundHandleScroll, false);
        window.addEventListener('load', this._boundHandleScroll, false);

        // Initialize state
        this.handleScroll();
      }

      getDistanceFromTop(element) {
        const rect = element.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        return rect.top + scrollTop;
      }

      handleScroll(e) {
        const STICKY_OFFSET = 180; // match scroll offset used in click handler
        const viewportHeight = window.innerHeight;

        // Recalculate sticky threshold on every tick (handles dynamic content/resizes)
        const amountScrolled = window.scrollY;
        this.distanceFromTop = this.getDistanceFromTop(this);
        const isFixed = amountScrolled > this.distanceFromTop;

        const viewportTop = isFixed ? STICKY_OFFSET : 0;
        const viewportBottom = viewportHeight;

        // Fix position of jump links
        if (isFixed) {
          this.classList.add('jump-links--fixed');
        } else {
          this.classList.remove('jump-links--fixed');
        }

        // Determine which section is actually in the viewport
        let activeSection = null;
        let maxVisible = 0;

        this.sections.forEach((section) => {
          const rect = section.getBoundingClientRect();
          const intersectionTop = Math.max(rect.top, viewportTop);
          const intersectionBottom = Math.min(rect.bottom, viewportBottom);
          const visiblePx = Math.max(0, intersectionBottom - intersectionTop);

          if (visiblePx > maxVisible) {
            maxVisible = visiblePx;
            activeSection = section;
          }
        });

        // Update link states
        const activeId = activeSection ? activeSection.id : null;
        this.links.forEach((link) => {
          const linkId = (link.hash || '').replace('#', '');
          if (activeId && linkId === activeId) {
            link.classList.add('jump-links__link--active');
          } else {
            link.classList.remove('jump-links__link--active');
          }
        });
      }

      disconnectedCallback() {
        if (this._boundHandleScroll) {
          window.removeEventListener('scroll', this._boundHandleScroll);
          window.removeEventListener('resize', this._boundHandleScroll);
          window.removeEventListener('load', this._boundHandleScroll);
        }
      }
    }
  );
}

